var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseleave":_vm.onSelectionChange}},[_c('vue-editor',{on:{"imageAdded":_vm.handleImageAdded,"selection-change":_vm.onSelectionChange},model:{value:(_vm.post),callback:function ($$v) {_vm.post=$$v},expression:"post"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }